module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_10_american-village-0d7343b6abf2de4f175e0ee219bd46f8.jpg";